export default __webpack_public_path__ + "static/media/logo.a65804c4.png";